import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import * as flyerDetailPageStore from "../../store/flyer-detail-page.store";
import { FlyerDetailPageView } from "../flyer-detail-page-view/flyer-detail-page-view.component";
import { useParams } from "react-router-dom";
import * as flyerStore from "../../../../../../store/flyer.store";
import * as flyerDetailStore from "../../../../store/flyer-detail.store";
import { hasPageDetails } from "../../types/flyer-detail-page-preview/flyer-detail-page-preview.functions";
import * as userStore from "../../../../../../../../features/user/store/user.store";
import { dateIsBeforeToday } from "../../../../../../../../utils/date-format.utils";

export const FlyerDetailPage = () => {
  const params = useParams<{ id: string; pageId: string }>();
  const pagePreview = useSelector(flyerDetailPageStore.getPagePreview);
  const user = useSelector(userStore.getUser);

  useEffect(() => {
    const pagePreviewUpdate = () => !pagePreview || pagePreview.pageId !== Number(params.pageId);
    const userInitialized = () => Boolean(user.id);

    if (pagePreviewUpdate() && userInitialized()) {
      flyerDetailPageStore.fetchPagePreview(params.pageId);
    }
  }, [pagePreview, params, user]);

  useEffect(() => {
    flyerDetailStore.fetchFlyer(params.id);
  }, [params.id]);

  const onBack = () => flyerDetailPageStore.navigateToFlyerPages(Number(params.id));

  return (
    <FlyerDetailPageView
      flyerEndDatePassed={dateIsBeforeToday(useSelector(flyerDetailStore.getEndAt))}
      pagePreview={useSelector(flyerDetailPageStore.getPagePreview)}
      pageTemplate={useSelector(flyerDetailPageStore.getPageTemplate)}
      editType={useSelector(flyerDetailPageStore.getEditType)}
      isLoading={useSelector(flyerDetailPageStore.isLoading)}
      selectedLanguage={useSelector(flyerDetailPageStore.getSelectedLanguage)}
      editPositionId={useSelector(flyerDetailPageStore.getEditPositionId)}
      hasPageDetails={hasPageDetails(pagePreview)}
      permissions={useSelector(flyerStore.getPermissions)}
      error={useSelector(flyerDetailPageStore.getError)}
      onCreatePagePosition={flyerDetailPageStore.createPagePosition}
      onEditPagePosition={flyerDetailPageStore.editPagePosition}
      onPageUpdate={flyerDetailPageStore.updatePage}
      onChangeEditType={flyerDetailPageStore.setEditType}
      onDrawerClose={flyerDetailPageStore.resetEditType}
      onDeSelectBlock={flyerDetailPageStore.deSelectBlock}
      onSelectLanguage={flyerDetailPageStore.selectLanguage}
      onBack={onBack}
    />
  );
};
